import config from '../config.js';

window.mqls = {};

Object.keys(config.mediaQueries)?.forEach(key => {
  window.mqls[key] = window.matchMedia(config.mediaQueries[key]);
});
